import { useEffect, useState } from "react";
import { cacheGet, cachedFetch } from "@/lib/cache";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Ruta de desarrollo (obligatoria) y, si la ruta no lleva los pasos de horma, la horma del catálogo (revisada o liberada).
// value = { ruta, horma_id } · onChange recibe el objeto completo. Reglas en backend/core/rutas.py (14-oct-2026).
export function useRutas() {
  const [rutas, setRutas] = useState(() => cacheGet("/rutas") ?? []);
  useEffect(() => { cachedFetch("/rutas", setRutas).catch(() => {}); }, []);
  return rutas;
}

export const rutaListo = (rutas, v) => {
  const r = rutas.find((x) => x.id === v?.ruta);
  return !!r && (r.horma_en_paso || !!v.horma_id);
};

export default function RutaHormaCampos({ value, onChange, testid = "ruta" }) {
  const rutas = useRutas();
  const [hormas, setHormas] = useState(() => (cacheGet("/hormas") ?? []).filter((h) => h.elegible));
  useEffect(() => { cachedFetch("/hormas", (d) => setHormas(d.filter((h) => h.elegible))).catch(() => {}); }, []);
  const r = rutas.find((x) => x.id === value?.ruta);

  return (
    <div className="grid sm:grid-cols-2 gap-3">
      <div className="space-y-1.5">
        <Label>Ruta de desarrollo *</Label>
        <Select value={value?.ruta || ""} onValueChange={(v) => onChange({ ...value, ruta: v })}>
          <SelectTrigger data-testid={`${testid}-select`}><SelectValue placeholder="Elige la ruta" /></SelectTrigger>
          <SelectContent>
            {rutas.map((x) => <SelectItem key={x.id} value={x.id}>{x.nombre} · {x.total} pasos</SelectItem>)}
          </SelectContent>
        </Select>
        {r && (
          <p className="text-[11px] text-slate-400">
            {r.horma_en_paso ? "La horma se elige en el paso 1." : "Usa una horma existente del catálogo."}
            {!r.con_prototipo && " Sin prototipo: la muestra la aprueba el cliente."}
          </p>
        )}
      </div>
      {r && !r.horma_en_paso && (
        <div className="space-y-1.5">
          <Label>Horma *</Label>
          <Select value={value?.horma_id || ""} onValueChange={(v) => onChange({ ...value, horma_id: v })}>
            <SelectTrigger data-testid={`${testid}-horma`}><SelectValue placeholder={hormas.length ? "Elige la horma" : "No hay hormas revisadas"} /></SelectTrigger>
            <SelectContent>
              {hormas.map((h) => <SelectItem key={h.id} value={h.id}>{h.codigo} · {h.nombre}{h.proveedor ? ` · ${h.proveedor}` : ""}</SelectItem>)}
            </SelectContent>
          </Select>
          {!hormas.length && <p className="text-[11px] text-amber-700">Pide a Desarrollo que libere la horma en el menú Hormas.</p>}
        </div>
      )}
    </div>
  );
}
